import Booking from "./bookings/Bookings";
import Form from "./form/Form";

export default function Main() {
    return (
        <section>
            <Form></Form>
            <Booking></Booking>
        </section>
    )
}